import makeRequest, { ERequestMethod } from '../../../../rest-api'

export const changeLanguage = async (selectedLanguage: string): Promise<void> =>
    makeRequest<void>({
        method: ERequestMethod.POST,
        url: `/Kayttaja/Language/_${selectedLanguage}`,
    })
